import { $api } from '@shared/apis';

/**
 * 쿠폰 다운로드 — `POST /api/v1/coupons/claim`.
 *
 * 로그인이 필요하다 — 비로그인으로 호출하면 실패하므로 호출 전에 로그인 여부를 확인한다.
 *
 * body 는 둘 중 하나로 보낸다.
 * - `couponIds`: 다운로드 가능 목록(`GET /api/v1/coupons/claimable`)에서 고른 쿠폰 id
 * - `code`: 사용자가 입력한 쿠폰 코드
 *
 * 응답의 `ids` 는 실제로 발급된 쿠폰 id 다.
 *
 * 발급 성공 시 보유·다운로드가능 카운트가 즉시 바뀌므로, 쿠폰 목록을 함께 보여주는
 * 화면이라면 `onSuccess` 에서 관련 쿼리를 무효화해야 한다.
 * (로그인 확인 + 무효화까지 묶은 `shared/hooks/useClaimCoupons` 를 먼저 검토할 것)
 *
 * @example
 * const claimCoupons = useMutation(claimCouponsMutationOptions());
 * claimCoupons.mutate({ body: { couponIds: [1, 2] } });
 * claimCoupons.mutate({ body: { code: 'WELCOME' } });
 */
export const claimCouponsMutationOptions = () =>
  $api.mutationOptions('post', '/api/v1/coupons/claim');
